import axios from "axios";

// Base do backend de Documentos Institucionais (card #16021 — Serviços TI/apisuni).
// Configurada via REACT_APP_API_BASE_URL (.env.local para desenvolvimento, .env.production para o build de produção — ainda a definir com o pipeline do site).
const API_BASE_URL = process.env.REACT_APP_API_DOCS_INSTITUCIONAIS;

/**
 * Busca as opções (categorias) ativas com seus arquivos ativos, já ordenadas do mais recente para o mais antigo. Opção inativa, ou ativa sem nenhum arquivo ativo, nunca vem no retorno (regra de negócio do backend).
 *
 * @returns {Promise<Array<{id: number, nome: string, descricao: string, arquivos: Array<{id: number, nome: string, url: string, formato: string, dataUpload: string}>}>>}
 */
export async function buscarOpcoesAtivas() {
  const response = await axios.get(`${API_BASE_URL}/opcoes/ativos`);
  return response.data?.data ?? [];
}
